import React from 'react';
import Reflux from 'reflux';
import {Button, message, Row, Col} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, DisplayForm} from '../../components';
import {detail} from '../../service/thingsOrder';
import moment from 'moment';
import './table.css';

class BuyReturnPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // opts: ['查看销售单'],
            // type: ~~this.props.params.type,
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: {},
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            value: '',
            // distributor:JSON.parse(window.sessionStorage.getItem('distributor'))
        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goBack = this.goBack.bind(this);
        this.goView = this.goView.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    print = () => {

    };

    /*获取列表数据*/
    initData() {
        let id = this.props.params.id;
        var realQuantityAll = 0;
        var amountAll = 0;
        var amountAll2 = 0;
        var amountAll3 = 0;
        const data = JSON.parse(window.sessionStorage.getItem('returngoodsprint'));
        for (let i = 0; i < data.lineList.length; i++) {
            data.lineList[i].id = i + 1;
            // realQuantityAll += data.lineList[i].gobackCount;
            realQuantityAll += data.lineList[i].realQuantity;
            amountAll += data.lineList[i].discountPrice;
            amountAll2 += data.lineList[i].discountMoney;
            data.lineList[i].discountPrice = data.lineList[i].discountPrice.toFixed(6);
            data.lineList[i].discountMoney = (data.lineList[i].discountPrice * data.lineList[i].realQuantity + 0.0000001).toFixed(2);
            amountAll3 = amountAll3 + Number(data.lineList[i].discountMoney);

        }
        var x = amountAll3.toFixed(2);
        var data1 = [...data.lineList];
        data1.push({
            id: 99999999,
            objDescription: '合计:',
            realQuantity: realQuantityAll, /*discountPrice:amountAll,*/
            discountMoney: x
        });
        this.setState({rows: data1, resultData: data, discountMoney1: x});
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {/*distributor, */rows, total, searchObj, resultData, type} = this.state;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: false,
            // pageParam: {
            //   total: total,
            //   current: searchObj.p,//当前页码
            //   pageSize: searchObj.s,//当前分页数
            //   onChange: this.pageChange
            // },
            columns: [

                {
                    title: '客户名称',
                    dataIndex: 'a',
                    render: (text, record, index) => {
                        if (index < rows.length - 1) {
                            return <span>{resultData.cusName}</span>
                        }
                        if (index = rows.length - 1) {
                            return <span>{''}</span>
                        }
                    }
                },
                {
                    title: '物料编码',
                    dataIndex: 'objCode'
                },
                {
                    title: '产品名称',
                    dataIndex: 'middleCat'
                },
                {
                    title: '规格型号',
                    dataIndex: 'objDescription'
                },
                {
                    title: '税收编码',
                    dataIndex: 'shuiCoce'
                },
                {
                    title: '数量',
                    dataIndex: 'realQuantity'
                },
                {
                    title: '单价(含税)',
                    dataIndex: 'discountPrice',
                    // render: (text,record,index) => {
                    //   return <div>{text.toFixed(2)}</div>
                    // }
                },
                {
                    title: '金额',
                    dataIndex: 'discountMoney',
                    render: (text, record, index) => {
                        return <div>{text || 0}</div>
                    }
                }
            ],
            paginationHide: true,
            rows
        };

        const h1 = {width: '100%', textAlign: 'center'}
        const shiwu = {textAlign: 'center'}
        const top = {width: '100%', textAlign: 'center', position: 'relative'}
        const printDate = moment(new Date()).format('YYYY/MM/DD');
        return (
            <div style={{padding: '20px', lineHeight: '30px', color: '#000'}}>

                <h1 style={h1}>回购协议</h1>
                <p>甲方: {resultData.orgId == '82' ? '浙江天正电气股份有限公司' : resultData.orgId == '86' ? '上海天毅行智能电气有限公司' : ''}</p>
                <p>乙方: {resultData.purchaseName || ''}</p>
                <p>甲方已向乙方销售的如下产品,乙方提出由甲方回购,甲方同意接受,现双方经友好协商,达成如下协议:</p>
                <p>一、货物明细</p>
                <div className='yourClass'><TableView {...tableViewProps} /></div>
                <p>二、价格、付款方式及期限: 本次回购金额人民币{this.state.discountMoney1 || 0}元,回购金额冲销乙方欠甲方的相关款项或用于其他产品的提货。</p>
                <p>三、本协议一式叁份,自双方盖章后生效。</p>
                <p>{'　'}</p>
                <div>
                    <p style={{float: 'left'}}> 甲方:{resultData.orgId == '82' ? '浙江天正电气股份有限公司' : resultData.orgId == '86' ? '上海天毅行智能电气有限公司' : ''}</p>
                    <p style={{float: 'right'}}>________年 ____月 ____日</p>
                </div>
                <p>{'　'}</p>
                <p>{'　'}</p>
                <div>
                    <p style={{float: 'left'}}> 乙方:{resultData.purchaseName || ''}</p>
                    <p style={{float: 'right'}}>________年 ____月 ____日</p>
                </div>
            </div>
        )
    }
}

export default BuyReturnPrint;


// WEBPACK FOOTER //
// ./src/routes/print/buyReturnPrint.js